import React from 'react';
import Post from '../../components/post';
import LazyLoadImage from '../../components/LazyLoadImage';


const ConsumerCreditCounselingCreditCounselingPage = () => {
    const article = {
        title: 'The Ultimate Consumer Credit Counseling Guide',
        slug: '/credit-counseling/consumer-credit-counseling/',
        date: '2018-03-29T15:24:06.000Z',
        modified: '2021-08-25T22:13:40.000Z',
        excerpt: 'Consumer credit counseling can help relieve the stress and anxiety that comes from being in debt. Learn how to get the right solution from a counselor for your financial problem with this comprehensive guide.',
        featured_image: {
            source_url: '/media/credit-counseling-guide.jpg',
        },
        acf: {
            seo_title: '',
            robots: 'index, follow',
        },
        read_time_minutes: 10,
        content: (
            <>
                <p>Americans are in record-breaking debt.</p>
                <p>Low financial literacy, easy access to credit cards and a snowballing student loan crisis are putting consumers in over their heads with no end in sight.</p>
                <p>Multiple monthly payments with high-interest rates fuel stress and anxiety, making it hard to not just give up.</p>
                <p>But giving up leads to defaulted loans, court judgments, and bankruptcy, which can leave your credit score in tatters and render you ineligible for a mortgage or car loan.</p>
                <p>
                    <LazyLoadImage alt="Credit Score at Mortgage Origination" src="/media/credit-score-at-mortgage-origination-1.png" />
                    {' '}
                </p>
                <p>With the highest outstanding credit card debt ever and millions of defaulted student loans, U.S. debt is taking a huge toll on the economy.</p>
                <p>The Federal Reserve Bank of New York reported that home ownership by people in their late 20s has declined by 35% as a result of student loan debt and that in turn suppresses economic activity.</p>
                <p>The health of the American economy depends on the financial health of its citizens.</p>
                <p>
                    <a href="https://www.debtconsolidation.com/credit-counseling/consumer-credit-counseling/">Consumer credit counseling</a>
                    {' '}
                    can help you get out of debt.
                </p>
                <p>Therefore, with the proper financial education and tools, you can repair your credit and access funds for the important purchases in life, like a home or car, and plan for the future with retirement savings.</p>
                <p>If you have already tried to reduce your debt on your own and failed, a consumer credit counselor can help you find the right solution to your financial problems and support you until you are debt-free.</p>
                <p>Let consumer credit counseling relieve the stress of owing more than you can afford and put you in control of your finances.</p>
                <h2 id="how-it-works">How It Works</h2>
                <h3>Get consumer credit counseling for customized financial guidance</h3>
                <p>
                    <strong>Confidential one-on-one sessions with a financial expert.</strong>
                    {' '}
                    Consumer credit counseling is a service offered by non-profit agencies or companies that provide guidance on financial matters.
                </p>
                <p>Whether it&rsquo;s too much debt, budgeting problems, or lack of financial knowledge, consumer credit counselors partner with clients to find the right solutions to their specific money problems.</p>
                <p>Private consumer credit counseling sessions are confidential and the counselors are non-judgmental, so no matter how deeply you&rsquo;re in debt or how little you understand the process, you get advice you need with zero shame.</p>
                <p>The American Institute of Certified Public Accountants found that about one-quarter (28%) of the country reports they stress every single day about financial decisions because of their debt.</p>
                <p>
                    <LazyLoadImage alt="Last year&rsquo;s financial stresses vs 2018&rsquo;s fears" src="/media/last-years-financial-stresses-vs-2018s-fears-2.png" />
                    {' '}
                </p>
                <p>
                    When over 1 out of 4 us are freaking out daily over money, it is
                    {' '}
                    <a href="https://www.debtconsolidation.com/credit-counseling/">time for us all to get financially healthy</a>
                    .
                </p>
                <h3>Many need consumer credit counseling now more than ever</h3>
                <p>
                    Americans owe a record-breaking $1.021
                    {' '}
                    <em>trillion</em>
                    {' '}
                    in outstanding credit card debt, according to the Federal Reserve.
                </p>
                <p>This may come as a surprise to those of us that thought it was free money only to discover we now have a wallet full of maxed out credit cards and are barely capable of making minimum payments.</p>
                <p>
                    <strong>Almost five million Americans have defaulted on their student loans.</strong>
                    {' '}
                    That number, according to the Wall Street Journal, represents 22% of all those with outstanding student loan debt.
                </p>
                <p>The consequences of defaulted student loans are severe and include garnished wages, accelerated interest payments, and inability to qualify for a mortgage or car loan.</p>
                <p>
                    <strong>Millennials struggle with overwhelming debt.</strong>
                    {' '}
                    The generation facing the student loan crisis says its debt is too much.
                </p>
                <p>And the numbers show that they are right.</p>
                <p>A study by National Endowment for Financial Education (NEFE) revealed that two-thirds of millennials have long-term debts and over 30% have long-term debt with two or more creditors.</p>
                <h2 id="consumer-credit-counseling-can-keep-you-out-of-court">Consumer Credit Counseling Can Keep You Out of Court</h2>
                <p>
                    <strong>You can avoid serious actions like court judgments and bankruptcy.</strong>
                    {' '}
                    Before defaulting on your student loan or allowing outstanding credit card bills to go into collections, let a credit counselor devise a repayment plan that can reduce your debt in affordable ways.
                </p>
                <p>
                    <strong>Consumer credit counseling tackles almost any kind of debt.</strong>
                    {' '}
                    Whether it&rsquo;s student loans, mortgages, car loans, personal loans, medical bills, housing costs, or credit card debt, a credit counselor can provide a workable solution to pay off your debt.
                </p>
                <p>
                    <strong>Consumer credit counseling takes the fear out of communicating with creditors.</strong>
                    {' '}
                    The best part is that the counselors negotiate a repayment plan with your creditors directly.
                </p>
                <p>It may seem ridiculous, but the struggle is real.</p>
                <p>Fear of money, or Chrematophobia, includes anxiety and/or avoidance in dealing with financial issues.</p>
                <h3>Lower your credit score, while staying eligible for student loans</h3>
                <p>People also worry that consumer credit counseling will hurt their FICO credit score.</p>
                <p>While credit counseling classes and private sessions will not affect your credit score, the debt management plan (DPM) put together by your credit counselor may use programs that will lower your credit score.</p>
                <p>
                    <strong>Debt consolidation and settlement programs will show up on your report.</strong>
                    {' '}
                    However, your
                    {' '}
                    <a href="https://www.debtconsolidation.com/credit-counseling/">credit score will quickly bounce back</a>
                    {' '}
                    after you&rsquo;re debt-free, and considering how much longer it takes to rebuild credit after a court judgment or bankruptcy, it is the best choice in the long run.
                </p>
                <p>
                    <strong>Repayment plans won&rsquo;t affect your ability to get a student loan.</strong>
                    {' '}
                    Government student loan approval
                    {' '}
                    <em>is not</em>
                    {' '}
                    based on credit reports or scores.
                </p>
                <p>
                    <LazyLoadImage alt="2017 Federal Funding Borrower Distribution by Student Loan Program" src="/media/2017-federal-funding-borrower-distribution-by-student-loan-program-3.png" />
                </p>
                <h3>You won&rsquo;t break the bank</h3>
                <p>
                    <strong>Most initial consumer credit counseling sessions are free.</strong>
                    {' '}
                    During your first session, a credit counselor will offer the best options based on your financial situation.
                </p>
                <p>
                    <strong>Costs depend on state regulations and vary by agency.</strong>
                    {' '}
                    Some states regulate consumer credit counseling agencies and cap fees on services.
                </p>
                <p>
                    <strong>Non-profit consumer credit counseling is free or really cheap.</strong>
                    {' '}
                    Member agencies of the
                    {' '}
                    <a href="https://www.nfcc.org/search-results/?q=credit+counseling+costs&amp;cx=000027011606866024496%3Ajlzeqr9utl0&amp;cof=FORID%3A11&amp;ie=UTF-8&amp;siteurl=www.nfcc.org%2Four-services%2Fcredit-debt-counseling%2F&amp;ref=www.nfcc.org%2F&amp;ss=4678j1189676j25" target="_blank" rel="noopener noreferrer">National Foundation for Credit Counseling (NFCC)</a>
                    {' '}
                    offer most services for free or at very low costs to clients—typically around $20.
                </p>
                <p>
                    <strong>Consumer credit counseling for-profit companies charge much higher fees.</strong>
                    {' '}
                    The
                    {' '}
                    <a href="http://fcaa.org/credit-counseling" target="_blank" rel="noopener noreferrer">Financial Counseling Association of America (FCAA</a>
                    ) members charge a DMP enrollment fee of about $75 and a monthly fee around $50, but these are estimates as fee structures differ by company.
                </p>
                <p>However, the FCAA does require members to offer fee waivers for those who cannot afford their services.</p>
                <h2 id="what-they-can-do-for-you">What They Can Do for You</h2>
                <h3>Debt and financial illiteracy go hand-in-hand</h3>
                <p>
                    <strong>Gen-Xers and millennials have trouble grasping money management concepts.</strong>
                    {' '}
                    The NEFE showed that a mere 24% of millennials showed basic financial literacy, and worse, only 8% scored high in understanding money matters.
                </p>
                <p>When asked how they will finance their retirement, according to Allianz Life, 46% of Gen-Xers replied they will &quot;figure it out when I get there.&quot; That&rsquo;s not smart.</p>
                <p>
                    <strong>You can improve your financial literacy.</strong>
                    {' '}
                    Consumer credit counseling agencies and companies provide financial education classes and resources that can fill the gaps in your money management knowledge.
                </p>
                <h3>Consumer credit counselors construct customized DMPs</h3>
                <p>
                    <strong>MPs could use consolidation, settlement, or a mixture of both and more.</strong>
                    {' '}
                    Your credit counselor uses accounting, debt, and spending details in order to create your DMP.
                </p>
                <p>Therefore, pull all financial documentation together before your first session.</p>
                <p>Your DPM could involve a cocktail of different programs like debt consolidation, debt settlement, tools to improve budgeting, and educational materials specific to where your financial knowledge is lacking.</p>
                <p>DMPs cannot be used to pay off secured debt (backed by collateral like a house or car).</p>
                <p>After you are debt-free, your credit counselor can help you with household budgeting and help you establish good credit.</p>
                <p>The goal is to get you out of debt, keep you out of debt, and give you the skills to achieve financial empowerment.</p>
                <p>
                    <strong>Know the details of the DMP before you enroll.</strong>
                    {' '}
                    Credit counselors should provide a breakdown of all fees and the length of time it will take to pay off your debt
                    {' '}
                    <em>before</em>
                    {' '}
                    you sign up.
                </p>
                <p>Usually, non-profit consumer credit counseling agencies require you to refrain from applying for any new credit or use any existing credit for the length of the DPM—around four years.</p>
                <p>
                    <LazyLoadImage alt="How Long Bankruptcy Remains On Your Credit" src="/media/how-long-bankruptcy-remains-on-your-credit-4.png" />
                </p>
                <p>
                    <strong>DMPs take discipline.</strong>
                    {' '}
                    If your DMP does not put restrictions on applying for new debt or when you have paid off all your debt, resist the temptation to apply for new credit.
                </p>
                <p>Be very careful not to run up your debt again.</p>
                <p>There are strategies that can help you stick to your DMP or budget so that you stay out of debt for good.</p>
                <h2 id="take-the-pain-out-of-monthly-payments">Take the Pain Out of Monthly Payments</h2>
                <p>
                    <strong>The first step in a debt consolidation plan is to reduce the total owed.</strong>
                    {' '}
                    By negotiating with your creditors, your credit counselor will seek lower interest rates and ask that any fees be waived so your monthly payments are affordable.
                </p>
                <p>
                    <strong>A debt reduction program that gives you a single monthly payment.</strong>
                    {' '}
                    Debt consolidation rolls all your debt into one total that you pay in monthly installments to the consumer credit counseling agency.
                </p>
                <p>Your consumer credit counselor then distributes payments to your creditors.</p>
                <p><strong>A debt consolidation program is not the same as a debt consolidation loan.</strong></p>
                <p>When a DMP uses a debt consolidation program, it is strictly a debt reduction process that does not take on any new debt.</p>
                <p>A debt consolidation loan is money you borrow from a lender, like a bank or credit union, at a lower interest rate than existing debt, which you then make monthly payments on to repay the loan.</p>
                <p>
                    <strong>You do not have to close all your accounts at the end of the program.</strong>
                    {' '}
                    Your consumer credit counselor can give you advice on which credit to maintain and which accounts to close.
                </p>
                <p>You can keep and improve your ability to access funds while learning how to repair your credit score and, ultimately, qualify for loans and mortgages.</p>
                <h3>Debt settlement pays off debt in one lump sum</h3>
                <p>
                    <strong>A quick &lsquo;n&rsquo; dirty way to pay less and stay out of bankruptcy.</strong>
                    {' '}
                    Debt settlement is a program reserved for those who owe massive amounts and cannot realistically afford the monthly payments of any other repayment plan.
                </p>
                <p>
                    After you
                    {' '}
                    <a href="https://www.debtconsolidation.com/debt-settlement/">enroll in a debt settlement program</a>
                    , your credit counselor will negotiate lower totals with all your creditors by offering to wipe out the entire balance in one payment.
                </p>
                <p>Creditors may agree because they prefer to collect something rather than nothing, which is what they will get if you declare bankruptcy.</p>
                <p>
                    <strong>Debt settlement is a last resort before bankruptcy.</strong>
                    {' '}
                    Your credit score really takes a beating when you settle your debt and it stays on your credit report for seven years.
                </p>
                <p>Bankruptcy stays on your report for 10 years and a good consumer credit counselor will advise you on how to repair your credit after the program ends.</p>
                <p>
                    <LazyLoadImage alt="Personal Bankruptcies from 2010-2017" src="/media/personal-bankruptcies-from-2010-2017-5.png" />
                </p>
                <p>Your credit counselor may ask you to stop paying monthly minimums to creditors for the length of the program (generally 2–4 years) and send them a single, monthly payment you can afford.</p>
                <p>The money accumulates in an escrow account until there is enough to pay off your debt.</p>
                <p>It&rsquo;s fast and effective but negatively affects your payment history, thus the lower credit score.</p>
                <p>
                    <strong>Debt settlement fees are pricey.</strong>
                    {' '}
                    Make sure your consumer credit counselor thoroughly covers the fee structure
                    {' '}
                    <em>before</em>
                    {' '}
                    you sign up for a debt settlement program.
                </p>
                <p>
                    <strong>Any credit counselor who asks for upfront fees is shady.</strong>
                    {' '}
                    Legitimate agencies and companies include fees in your monthly payment or add them to the total amount of debt you are paying off.
                </p>
                <p>
                    <strong>Fee assessment varies by agency or company.</strong>
                    {' '}
                    Your consumer credit counseling agency or company will determine debt settlement fees in one of three ways:
                </p>
                <ul className="list">
                    {' '}
                    <li>a percentage of the total debt</li>
                    {' '}
                    <li>a percentage of the debt reduction, or</li>
                    {' '}
                    <li>a fixed amount added to your monthly payments.</li>
                </ul>
                <p>
                    <strong>The usual range for percentage of total debt fees is 13–20%.</strong>
                    {' '}
                    If you were $30,000 in the hole, you would pay $3,900–$6,000 in fees.
                </p>
                <p>
                    <strong>Percentage of debt reduction fees can be as high as 35%.</strong>
                    {' '}
                    Again, let&rsquo;s say your total debt was $30,000, but your consumer credit counselor negotiated a settlement that cut that in half to $15,000.
                </p>
                <p>If debt settlement fee was 27%, it would be $4,050.</p>
                <p>
                    <strong>Debt settlement fees paid monthly are about $20–$90.</strong>
                    {' '}
                    These fees are automatically added to the amount you pay every month.
                </p>
                <h3>Consumer credit counseling provides bankruptcy alternatives</h3>
                <p>
                    <strong>Sometimes bankruptcy is the best option.</strong>
                    {' '}
                    Losing your job or astronomical medical bills are
                    {' '}
                    <a href="https://www.debtconsolidation.com/bankruptcy/">two of many reasons</a>
                    {' '}
                    bankruptcy could be the right financial decision.
                </p>
                <p>
                    <strong>You must finish consumer credit counseling before you can go bankrupt.</strong>
                    {' '}
                    The federal government requires approved pre-bankruptcy credit counseling and pre-discharge debtor education to legally declare bankruptcy.
                </p>
                <p>
                    <strong>Student loan debt cannot be discharged by bankruptcy.</strong>
                    {' '}
                    Your student loans are one of several
                    {' '}
                    <a href="https://www.debtconsolidation.com/bankruptcy/">debts that won&rsquo;t go away</a>
                    {' '}
                    if you declare bankruptcy, but there are other ways to tackle student loan debt.
                </p>
                <h2 id="start-your-post-school-career-off-on-the-right-foot">Start Your Post-School Career Off on the Right Foot</h2>
                <h3>Consumer credit counseling can help reduce and pay off student loan debt</h3>
                <p>
                    <strong>Consumer credit counselors approach student loan debt differently.</strong>
                    {' '}
                    Unlike other consumer debt, government and private student loans have different rules that a credit counselor can help you understand.
                </p>
                <p>
                    <strong>Repayment and consolidation programs are available.</strong>
                    {' '}
                    A consumer credit counselor can detail these programs and help you decide which one is right for you.
                </p>
                <p>
                    <strong>Credit counselors can identify possible debt reduction opportunities.</strong>
                    {' '}
                    Your credit counselor can show you options for loan cancellation and forgiveness, as well as ways to reduce interest.
                </p>
                <h3>Don&rsquo;t let debt-stress take a toll on your health or wealth</h3>
                <p>With consumer credit counseling, you have a partner to help you pay off your debt and repair your credit.</p>
                <p>The right one will teach you how to stay debt-free, stick to your budget, and begin saving for retirement.</p>
                <p>It will empower you to make good financial decisions about buying a home, a car, or investing your money.</p>
                <p>You do not have to face your financial problems alone.</p>
                <p>Have you ever used a credit counselor?</p>
                <p>How wonderful (or horrible) was the experience?</p>
                <p>We&rsquo;d love to know. Leave us a comment below.</p>
            </>
        ),
    };

    return (
        <Post article={article} />
    );
};

export default ConsumerCreditCounselingCreditCounselingPage;
